/* eslint-disable jsx-a11y/anchor-is-valid */
import './index.less';
import { SvgIcon, Pagination } from '@/components';
import Tabs, { TabPane } from 'rc-tabs';
import bannerImg from '@/assets/img/phone.png';
import { useState } from 'react';

// TODO: 补充跳转链接
const newsList = [
  // {
  //   label: '小部件技术规范与系统能力说明',
  //   url: 'https://dev.mi.com/console/doc/detail?pId=2452',
  //   date: '2021 年 8 月 13 日',
  // },
  // {
  //   label: '小部件适配规范',
  //   url: 'https://dev.mi.com/console/doc/detail?pId=2454',
  //   date: '2021 年 8 月 13 日',
  // },
  {
    label: '待更新...',
    url: '',
    date: '',
  },
];

const faqList = [
  // {
  //   label: '小部件常见问题',
  //   url: 'https://dev.mi.com/console/doc/detail?pId=2453',
  //   date: '2021 年 8 月 13 日',
  // },
  // {
  //   label: '小部件审核规范',
  //   url: 'https://dev.mi.com/console/doc/detail?pId=2460',
  //   date: '2021 年 8 月 13 日',
  // },
  {
    label: '待更新...',
    url: '',
    date: '',
  },
];

export default function BizIntro() {
  const pageSize = 4;
  const [newsListCurrentPage, setNewsListCurrentPage] = useState<number>(1);
  const [faqListCurrentPage, setFaqListCurrentPage] = useState<number>(1);

  const handleNewsListPageChange = (currentPage: number) => {
    setNewsListCurrentPage(currentPage);
  };
  const handleFaqListPageChange = (currentPage: number) => {
    setFaqListCurrentPage(currentPage);
  };

  return (
    <div className="main-content-wrapper biz-intro-wrapper">
      <div className="main-content biz-intro">
        <img src={bannerImg} alt="" />
        <div className="biz-intro__main">
          <div>
            <p className="biz-intro__title">
              <span className="em">{window.trans('widget')}</span>
              <span className="btn">{window.trans('developer-platform')}</span>
            </p>
            <p className="biz-intro__desc">
              {window.trans('platform-desc1')}
              <br />
              {window.trans('platform-desc2')}{' '}
              <a
                className="mag-link"
                href="https://dev.mi.com/console/doc/detail?pId=2466"
                target="_blank"
                rel="noreferrer"
              >
                {window.trans('platform-desc3')}
              </a>{' '}
              {window.trans('platform-desc4')}
            </p>
          </div>
          {/* <Tabs defaultActiveKey="1" style={{ marginTop: '88px' }}>
            <TabPane tab="最新消息" key="1">
              <ul className="biz-intro-list">
                {newsList
                  .slice(
                    (newsListCurrentPage - 1) * pageSize,
                    newsListCurrentPage * pageSize,
                  )
                  .map((item, index) => (
                    <li key={index}>
                      <a
                      // href={item.url} target="_blank" rel="noreferrer"
                      >
                        <span className="tag">公告</span>
                        <span className="title">{item.label}</span>
                        <span className="date">{item.date}</span>
                      </a>
                    </li>
                  ))}
              </ul>
              <Pagination
                className="biz-intro-pagination"
                total={newsList.length}
                defaultPageSize={pageSize}
                onChange={handleNewsListPageChange}
              />
            </TabPane>
            <TabPane tab="常见问题" key="2">
              <ul className="biz-intro-list">
                {faqList
                  .slice(
                    (faqListCurrentPage - 1) * pageSize,
                    faqListCurrentPage * pageSize,
                  )
                  .map((item, index) => (
                    <li key={index}>
                      <a
                      // href={item.url} target="_blank" rel="noreferrer"
                      >
                        <span className="title">{item.label}</span>
                        <span className="date">{item.date}</span>
                      </a>
                    </li>
                  ))}
              </ul>
              <Pagination
                className="biz-intro-pagination"
                total={faqList.length}
                defaultPageSize={pageSize}
                onChange={handleFaqListPageChange}
              />
            </TabPane>
          </Tabs> */}
        </div>
        <div className="swiper-down-wrapper">
          <span>{window.trans('slip-down')}</span>
          <SvgIcon name="mouse" />
          <SvgIcon name="down" />
        </div>
      </div>
    </div>
  );
}
